import moment from 'moment';
import findIndex from 'lodash/findIndex';

const parseDate = (utcDateToFormat, language) => ({
  utcValue: utcDateToFormat,
  datePart: !utcDateToFormat ||
    moment(utcDateToFormat).locale(language).format('ll'),
  timePart: moment(utcDateToFormat).locale(language).format('LT'),
});

export const mapVisits = (items, language) =>
  items.map((item) => ({
    ...item,
    encounterDate: parseDate(item.encounterDate, language),
  }));

export const findVisitIndex = (visits, identifier) => findIndex(visits, { identifier });
